/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Workout_View_DetailsInputs */

const en_us2_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`See details of ${i?.name}`)
};

const pt_br2_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalhes de ${i?.name}`)
};

const es_419_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalles de ${i?.name}`)
};

const pt_pt2_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ver detalhes de ${i?.name}`)
};

const fr_fr2_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voir les détails de ${i?.name}`)
};

const de_de2_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Details zu ${i?.name} ansehen`)
};

const it_it2_workout_view_details = /** @type {(inputs: Workout_View_DetailsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vedi i dettagli di ${i?.name}`)
};

/**
* | output |
* | --- |
* | "See details of {name}" |
*
* @param {Workout_View_DetailsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_view_details = /** @type {((inputs: Workout_View_DetailsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_View_DetailsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_view_details(inputs)
	if (locale === "es-419") return es_419_workout_view_details(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_view_details(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_view_details(inputs)
	if (locale === "de-DE") return de_de2_workout_view_details(inputs)
	if (locale === "it-IT") return it_it2_workout_view_details(inputs)
	return en_us2_workout_view_details(inputs)
});
export { workout_view_details as "workout.view_details" }